import styled from 'styled-components';

import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import { Typography } from 'src/app/components/Elements/Typography';

export const MedicationHeader = styled(Typography)`
  padding: 0 !important;
  font-family: ${props => props.theme.fonts.circular};
  margin-bottom: ${props => props.theme.space.s5} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
`;

export const MedicationItem = styled.li`
  margin-bottom: ${props => props.theme.space.s3};
  display: flex;
  align-items: center;
`;

export const MedicationLabel = styled.span`
  margin-left: ${props => props.theme.space.s2};
  font-size: ${props => props.theme.fontSizes.body};
`;

export const Divider = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${props => props.theme.colors.capsuleGray10};
  margin: ${props => props.theme.space.s7} ${props => props.theme.space.none};
`;

export const SectionTitle = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.small};
  line-height: ${props => props.theme.lineHeights.body};
  letter-spacing: ${props => props.theme.letterSpacings.one};
  text-transform: uppercase;
  color: ${props => props.theme.colors.capsuleGray50};

  margin-top: ${props => props.theme.space.s5};
  margin-bottom: ${props => props.theme.space.s2};
`;

export const StyledList = styled.ul`
  margin-top: ${({ theme }) => theme.space.s3};
  margin-bottom: ${({ theme }) => theme.space.s5};
`;

export const StyledLinkButton = styled(LinkButton)`
  width: 100% !important;

  ${props => props.theme.mediaQueries.small} {
    width: 50% !important;
  }
`;

export const TransferTypeInfoSection = styled.div`
  margin-bottom: ${props => props.theme.space.s3};
  display: flex;
  align-items: center;
`;

export const TransferTypeInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
